import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPage.css';
import SEOHelmet from '../components/SEOHelmet';

function TermsConditions() {
  return (
    <div className="legal-page">
      <SEOHelmet 
        title="Terms and Conditions - Stratagease"
        description="Terms and conditions for using Stratagease website and services. Clear rights and obligations for all users."
      />
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>Terms and Conditions</h1>
        <p className="legal-intro">The acceptable use of the content on our marketing strategy website and app clearly protects visitors to our sites. Please email us if you have questions about our website and app terms and conditions.</p>

        <div className="legal-content">
          <h2>Transparent Rights and Obligations</h2>
          <p className="legal-subtitle">TERMS AND CONDITIONS</p>
          <p className="legal-date">Last updated September 13, 2022</p>

          <h3>TABLE OF CONTENTS</h3>
          <ol className="toc">
            <li>AGREEMENT TO TERMS</li>
            <li>INTELLECTUAL PROPERTY RIGHTS</li>
            <li>USER REPRESENTATIONS</li>
            <li>USER REGISTRATION</li>
            <li>PROHIBITED ACTIVITIES</li>
            <li>USER GENERATED CONTRIBUTIONS</li>
            <li>CONTRIBUTION LICENSE</li>
            <li>GUIDELINES FOR REVIEWS</li>
            <li>MOBILE APPLICATION LICENSE</li>
            <li>SUBMISSIONS</li>
            <li>THIRD-PARTY WEBSITE AND CONTENT</li>
            <li>ADVERTISERS</li>
            <li>SITE MANAGEMENT</li>
            <li>PRIVACY POLICY</li>
            <li>TERM AND TERMINATION</li>
            <li>MODIFICATIONS AND INTERRUPTIONS</li>
            <li>GOVERNING LAW</li>
            <li>DISPUTE RESOLUTION</li>
            <li>CORRECTIONS</li>
            <li>DISCLAIMER</li>
            <li>LIMITATIONS OF LIABILITY</li>
            <li>INDEMNIFICATION</li>
            <li>USER DATA</li>
            <li>ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</li>
            <li>CALIFORNIA USERS AND RESIDENTS</li>
            <li>MISCELLANEOUS</li>
            <li>CONTACT US</li>
          </ol>

          <h3>1. AGREEMENT TO TERMS</h3>
          <p>These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and Stratagease Ltd, doing business as Stratagease ("Stratagease," "we," "us," or "our"), concerning your access to and use of the <a href="https://www.stratagease.com" target="_blank" rel="noopener noreferrer">https://www.stratagease.com</a> website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site").</p>

          <p>We are registered in England and have our registered office at 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ. You agree that by accessing the Site, you have read, understood, and agreed to be bound by all of these Terms of Use.</p>
          
          <p><strong>IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY.</strong></p>

          <p>The Site is intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Site.</p>

          <h3>2. INTELLECTUAL PROPERTY RIGHTS</h3>
          <p>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the "Content") and the trademarks, service marks, and logos contained therein (the "Marks") are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, international copyright laws, and international conventions.</p>

          <h3>14. PRIVACY POLICY</h3>
          <p>We care about data privacy and security. Please review our Privacy Policy: <Link to="/privacy-policy">Privacy Policy</Link>. By using the Site, you agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use.</p>

          <h3>17. GOVERNING LAW</h3>
          <p>These Terms shall be governed by and defined following the laws of England. Stratagease Ltd and yourself irrevocably consent that the courts of England shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.</p>

          <h3>18. DISPUTE RESOLUTION</h3>
          <h4>Informal Negotiations</h4>
          <p>To expedite resolution and control the cost of any dispute, controversy, or claim related to these Terms of Use (each "Dispute" and collectively, the "Disputes") brought by either you or us (individually, a "Party" and collectively, the "Parties"), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided below) informally for at least thirty (30) days before initiating arbitration.</p>

          <h4>Binding Arbitration</h4>
          <p>Any dispute arising out of or in connection with this contract, including any question regarding its existence, validity, or termination, shall be referred to and finally resolved by the International Commercial Arbitration Court under the European Arbitration Chamber (Belgium, Brussels, Avenue Louise, 146) according to the Rules of this ICAC. The number of arbitrators shall be three (3). The seat, or legal place, of arbitration shall be London, England. The language of the proceedings shall be English. The governing law of the contract shall be the substantive law of England.</p>

          <h3>27. CONTACT US</h3>
          <p>In order to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</p>
          <p>Stratagease Ltd<br />
          <a href="mailto:mail@stratagease.com">mail@stratagease.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default TermsConditions;